const initialStateProducts = {
  shuffledProducts: [],
  allData: [],
};

const PRODUCTS_UPDATE_SHUFFLEDPRODUCTS = 'PRODUCTS/UPDATE_SHUFFLEDPRODUCTS';
const PRODUCTS_UPDATE_ALLDATA = 'PRODUCTS/UPDATE_ALLDATA';

export const updateProducts = shuffledProducts => ({ type: PRODUCTS_UPDATE_SHUFFLEDPRODUCTS, shuffledProducts });
export const updateAlldata = allData => ({ type: PRODUCTS_UPDATE_ALLDATA, allData });

export const products = (state = initialStateProducts, action) => {
  switch (action.type) {
    case PRODUCTS_UPDATE_SHUFFLEDPRODUCTS:
      return {
        ...state,
        shuffledProducts: action.shuffledProducts,
      };
    case PRODUCTS_UPDATE_ALLDATA:
      return {
        ...state,
        allData: action.allData,
      };
    default:
      return state;
  }
};
